export function handleGetSettingsError(getSettingsFn, newError) {
    try {
        return getSettingsFn();
    }
    catch {
        throw new Error(newError);
    }
}
